// import React, { createContext, useState, useEffect, useContext, useCallback } from "react";
// import { fetchThemeAndVendor, updateTheme } from "./themeService";
// import debounce from "lodash.debounce";
// import { InfiLoader } from "../components/loader";
// import { useUser } from "./userProvider";

// const ThemeContext = createContext();

// const defaultTheme = {
//   sideBar: {
//     textColour: "#fffffz",
//     bgColour: "#333331",
//     borderColor: "#4444441",
//     activeNavBgColour: "#5555551",
//     activeNavTextColour: "#ffffff1",
//     hoveredTextColor: "#eeeeee1",
//     hoveredBgColor: "#007bff1",
//     hoveredBorderColor: "#777771",
//   },
//   buttons: {
//     primaryBtnTextColour: "#ffffff1",
//     primaryBtnBgColour: "#007bff1",
//     primaryBtnBorderColor: "#0056b31",
//     secondaryBtnTextColour: "#0000001",
//     secondaryBtnBgColour: "#f8f9fa1",
//     secondaryBtnBorderColor: "#d6d8db1",
//     disabledBtnTextColour: "#6c757d1",
//     disabledBtnBgColour: "#e9ecef1",
//     disabledBtnBorderColor: "#ced4d1a",
//   },
// };

// export const ThemeProvider = ({ children }) => {
//   const [theme, setTheme] = useState(null);
//   const [vendor, setVendor] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const { userData } = useUser();
//   // console.log("userData 39", userData);

//   // useEffect(() => {
//   //   // loadTheme();
//   //   loadThemeAndVendor();
//   // }, []);

//   const resetCSSVariables = () => {
//     const root = document.documentElement;
//     Object.keys(theme || {}).forEach((key) => {
//       root.style.removeProperty(`--${key}`);
//     });
//   };

//   const applyCSSVariables = (themeObj) => {
//     resetCSSVariables();
//     Object.entries(themeObj).forEach(([key, value]) => {
//       document.documentElement.style.setProperty(`--${key}`, value);
//     });
//   };

//   // const loadTheme = async () => {
//   //   setLoading(true);
//   //   try {
//   //     const fetchedTheme = await fetchTheme(userData?.vendorDetails?.vendorObjId);
//   //     const validTheme = fetchedTheme?.theme || defaultTheme;
//   //     setTheme(validTheme);
//   //     applyCSSVariables(validTheme);
//   //   } catch (err) {
//   //     setError("Error fetching theme");
//   //     setTheme(defaultTheme);
//   //     applyCSSVariables(defaultTheme);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
//   // const loadThemeAndVendor = async () => {
//   //   setLoading(true);
//   //   try {
//   //     const fetchedThemeAndVendor = await fetchThemeAndVendor(
//   //       userData?.vendorDetails?.vendorObjId
//   //     );
//   //     // console.log("fetchedThemeAndVendor", fetchedThemeAndVendor);
//   //     const validTheme =
//   //       fetchedThemeAndVendor?.data?.theme != null
//   //         ? fetchedThemeAndVendor.data.theme
//   //         : defaultTheme;
//   //     setTheme(validTheme);
//   //     applyCSSVariables(validTheme);
//   //     setVendor(fetchedThemeAndVendor?.data?.vendor);
//   //   } catch (err) {
//   //     setError("Error fetching theme");
//   //     setTheme(defaultTheme);
//   //     applyCSSVariables(defaultTheme);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
//   const loadThemeAndVendor = useCallback(async () => {
//     setLoading(true);
//     try {
//       const fetchedThemeAndVendor = await fetchThemeAndVendor(
//         userData?.vendorDetails?.vendorObjId,
//       );

//       const validTheme =
//         fetchedThemeAndVendor?.data?.theme != null
//           ? fetchedThemeAndVendor.data.theme
//           : defaultTheme;

//       setTheme(validTheme);
//       applyCSSVariables(validTheme);
//       setVendor(fetchedThemeAndVendor?.data?.vendor);
//     } catch (err) {
//       setError("Error fetching theme");
//       setTheme(defaultTheme);
//       applyCSSVariables(defaultTheme);
//     } finally {
//       setLoading(false);
//     }
//   }, [userData?.vendorDetails?.vendorObjId]);


//     useEffect(() => {
//     loadThemeAndVendor();
//   }, [loadThemeAndVendor]);


//   const saveTheme = debounce(async (newTheme) => {
//     try {
//       await updateTheme(newTheme);
//       setTheme(newTheme);
//       applyCSSVariables(newTheme);
//       // console.log("newTheme 121", newTheme);
//     } catch (err) {
//       setError("Error updating theme");
//     }
//   }, 500);

//   const reloadTheme = async () => {
//     await loadThemeAndVendor();
//   };

//   return (
//     <ThemeContext.Provider
//       value={{ theme, saveTheme, loading, error, reloadTheme, vendor }}
//     >
//       {loading ? <InfiLoader maintext="Initializing..." /> : children}
//     </ThemeContext.Provider>
//   );
// };

// //working code
// // {
// //    <ThemeContext.Provider
// // value={{ theme, saveTheme, loading, error, reloadTheme, vendor }}
// // >
// // {loading ? (
// //   <InfiLoader maintext="Dashboard Initializing..." />
// // ) : error ? (
// //   <div className="theme-error">{error}</div>
// // ) : (
// //   children
// // )}
// // </ThemeContext.Provider>
// // }

// export const useTheme = () => useContext(ThemeContext);












import React, { createContext, useState, useEffect, useContext, useCallback, useRef } from "react";
import { fetchThemeAndVendor, updateTheme } from "./themeService";
import debounce from "lodash.debounce";
import { InfiLoader } from "../components/loader";
import { useUser } from "./userProvider";

const ThemeContext = createContext();

const defaultTheme = {
  sideBar: {
    textColour: "#ffffff",
    bgColour: "#333331",
    borderColor: "#444444",
    activeNavBgColour: "#555555",
    activeNavTextColour: "#ffffff",
    hoveredTextColor: "#eeeeee",
    hoveredBgColor: "#007bff",
    hoveredBorderColor: "#777777",
  },
  buttons: {
    primaryBtnTextColour: "#ffffff",
    primaryBtnBgColour: "#007bff",
    primaryBtnBorderColor: "#0056b3",
    secondaryBtnTextColour: "#000000",
    secondaryBtnBgColour: "#f8f9fa",
    secondaryBtnBorderColor: "#d6d8db",
    disabledBtnTextColour: "#6c757d",
    disabledBtnBgColour: "#e9ecef",
    disabledBtnBorderColor: "#ced4da",
  },
};

export const ThemeProvider = ({ children }) => {
  const { userData } = useUser();
  const vendorObjId = userData?.vendorDetails?.vendorObjId;

  const [theme, setTheme] = useState(null);
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const hasLoaded = useRef(false);

  // CSS Helper Functions
  const resetCSSVariables = useCallback(() => {
    const root = document.documentElement;
    if (theme) {
      Object.keys(theme).forEach((key) => {
        root.style.removeProperty(`--${key}`);
      });
    }
  }, [theme]);

  const applyCSSVariables = useCallback((themeObj) => {
    const root = document.documentElement;
    Object.entries(themeObj).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value);
    });
  }, []);

  // Load Theme Function
  const loadThemeAndVendor = useCallback(async () => {
    if (!vendorObjId || hasLoaded.current) return;

    setLoading(true);
    hasLoaded.current = true;

    try {
      const response = await fetchThemeAndVendor(vendorObjId);
      const validTheme = response?.data?.theme ?? defaultTheme;

      setTheme(validTheme);
      setVendor(response?.data?.vendor);

      resetCSSVariables();
      applyCSSVariables(validTheme);
    } catch (err) {
      console.error("Theme fetch error:", err);
      setError("Error fetching theme");
      setTheme(defaultTheme);
      applyCSSVariables(defaultTheme);
    } finally {
      setLoading(false);
    }
  }, [vendorObjId, resetCSSVariables, applyCSSVariables]);

  // Initial Load
  useEffect(() => {
    if (vendorObjId) {
      loadThemeAndVendor();
    }
  }, [vendorObjId, loadThemeAndVendor]);

  // Debounced Save Theme
  const saveTheme = debounce(async (newTheme) => {
    try {
      await updateTheme(newTheme);
      setTheme(newTheme);
      resetCSSVariables();
      applyCSSVariables(newTheme);
    } catch (err) {
      setError("Error updating theme");
      console.error(err);
    }
  }, 600);

  const reloadTheme = async () => {
    hasLoaded.current = false;
    await loadThemeAndVendor();
  };

  return (
    <ThemeContext.Provider
      value={{
        theme,
        saveTheme,
        loading,
        error,
        reloadTheme,
        vendor,
      }}
    >
      {loading ? <InfiLoader maintext="Initializing Theme..." /> : children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);